<template lang="pug">
  dv-maska-field(
    v-bind="extraAttrs"
    v-on="$listeners"
    :value="value"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import DvMaskaField from './DvMaskaField.vue';
import isNil from 'lodash/isNil';

export default {
  components: {
    DvMaskaField,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    min: {
      type: Number,
      default: Number.MIN_SAFE_INTEGER,
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER,
    },
    value: {
      type: [Number, String],
      default: undefined,
    },
  },
  data() {
    return {
      maskaOptions: {
        mask: 'N',
        tokens: {
          N: {
            pattern: /[-0-9]/,
            multiple: true,
          },
        },
        preProcess: (v) => v.replace(/(?!^)-/g, ''),
        postProcess: (v) => {
          const { min, max } = this;

          if (isNil(v) || (typeof v === 'string' && !v)) return v;

          if (v < min) return min.toString();
          if (v > max) return max.toString();

          return v;
        },
        serializer: (v) => {
          const outputValue = Number(v);

          if (
            isNil(v)
            || Number.isNaN(outputValue)
            || (typeof v === 'string' && !v)
          ) return '';

          return outputValue;
        },
      },
    };
  },
  computed: {
    extraAttrs() {
      const { $attrs, maskaOptions } = this;

      return {
        ...$attrs,
        maskaOptions,
      };
    },
  },
};
</script>
